import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Etasje from './Etasje.jsx'
import EtasjeIcon from '../../../images/Etasje.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class EtasjeList extends Component {
    state = {
        etasjer: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null
    }

    getEtasjer = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}/etasje`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                etasjer: [...this.state.etasjer, ...data.etasjer].sort(this.etasjeComparer),
                isLoading: false,
                continuationToken: data.nextContinuationToken})
        })
      }

      etasjeComparer = (a, b) => {
        if (a.etasjenummer == null || b.etasjenummer == null) return 1
        if (a.etasjenummer > b.etasjenummer) return 1
        if (a.etasjenummer < b.etasjenummer) return -1
        return 0
    }

    toggleEtasjer = () => {
        if (this.props.antall == 0) return
                
        if (this.state.etasjer.length == 0) {
            this.getEtasjer()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props        
        var antallEtasjer = this.state.continuationToken ? `${this.state.etasjer.length}/${this.props.antall}` : this.props.antall
        return (
            <li>
                <div className="section-header" onClick={this.toggleEtasjer}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={EtasjeIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('etasjer')} ({antallEtasjer})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.etasjer.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.etasjer.map((e, index) => { return (<Etasje key={e.etasjeId} etasje={e} antall={this.props.antall} isLast={index==this.state.etasjer.length-1} onEvent={this.props.onEvent} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getEtasjer}>
                                <span>{t('hent.etasjer')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(EtasjeList)